// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c9058f81","732":"f47f6e2d","977":"954e2075"}[chunkId] + ".chunk.js";
};